<template>
    <section class="t-courses" v-if="data">
        <div class="t-courses__header">
            <h2>
                {{ title }}
            </h2>
            <router-link v-if="link && !mobileState" :to="{name: link.url}" class="t-btn t-btn_white"><span>{{ link.title }}</span>
            </router-link>
            <div class="t-courses__arrows" :class="{_hidden: data.length <= 3}" v-if="!mobileState">
                <div :class="'t-courses__prev t-courses__prev_' + type">
                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 4H13M1 4L5 1M1 4L5 7" stroke="#52A8F2" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round"/>
                    </svg>
                </div>
                <div :class="'t-courses__next t-courses__next_' + type">
                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 4H1M13 4L9 1M13 4L9 7" stroke="#52A8F2" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>

        </div>
        
        <div class="t-courses__body" :class="{'t-work-area__cell': !mobileState}">
            <swiper class="t-courses-table__list" 
                    :options="mobileState? swiperOption_courses_mobile : swiperOption_courses" >
                <swiper-slide v-for="(item, index) in sorted" :key="'t-courses-table__list' + index" class="t-courses-table__listItem">
                    <router-link v-if="data" :to="{name: 'courses_info', params: {id: item.id, slug: item.slug}}"
                                class="t-courses-tableItem"
                                :class="{_belonging: item.belonging}">
                        <div class="t-courses-tableItem__price">
                            <span>{{ item.price }}</span><img src="/img/rub.png">
                        </div>
                        <p class="t-courses-tableItem__length">{{title_string(item)}}</p>
                        <p class="t-courses-tableItem__date" v-if="item.nearFuture">{{item.nearFuture.dateBegin}}</p>
                        <p class="t-courses-tableItem__description">{{ item.name }}</p>
                    </router-link>
                </swiper-slide>
            </swiper>
            <!-- :class="{'_flex-start':(articles.items.length > 5)}" -->
            <div class="t-courses__pagination t-courses-table__pagination " :class="['t-courses__pagination_' + type, {'_flex-start':(sorted.length > 5)}]" v-if="mobileState"></div>
        </div>
        <div class="t-courses__footer">
            <router-link v-if="link && mobileState" :to="{name: link.url}" class="t-btn t-btn_white t-btn_full"><span>{{ link.title }}</span>
            </router-link>
        </div>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex'

    import SmallTableItem from './SmallTableItem.vue'

    export default {
        data() {
            return {
                swiperOption_courses: {
                    init: false,
                    direction: 'vertical',
                    slidesPerView: 'auto',
                    freeMode: true,
                    mousewheel: true
                },
                swiperOption_courses_mobile: {
                    autoHeight: true,
                    slidesPerView: 1,
                    spaceBetween: 24,
                    threshold: 10,
                    pagination: {
                        el: '.t-courses__pagination_' + this.type,
                        dynamicBullets: true
                    }
                }
            }
        },
        components: {
            'cmp-course': SmallTableItem
        },
        computed: {
            ...mapGetters(['mobileState']),
            ...mapGetters('staticText', ['hoursArr', 'minuteArr', 'lessonsCountArr', 'courseTypeArr']),
            sorted() {
                let sortedData = this.data.sort((a, b) => {
                    if (!a.nearFuture || !a.nearFuture.dateBegin || !b.nearFuture || !b.nearFuture.dateBegin) {
                        return -1;
                    }

                    return (new Date(a.nearFuture.dateBegin)) > (new Date(b.nearFuture.dateBegin)) ? -1 : 1;
                });
                Object.keys(sortedData).map((index) => {
                    if (sortedData[index]['nearFuture'] && sortedData[index]['nearFuture']['dateBegin']) {
                        let newDate = new Date(sortedData[index]['nearFuture']['dateBegin']);
                        let hours = newDate.getHours() < 10 ? `0${newDate.getHours()}` : newDate.getHours();
                        let minutes = newDate.getMinutes() < 10 ? `0${newDate.getMinutes()}` : newDate.getMinutes();
                        let day = newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate();
                        let month = newDate.getMonth() + 1 < 10 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1;
                        let year = newDate.getFullYear();
                        sortedData[index]['nearFuture']['dateBegin'] = `${day}.${month}.${year} ${hours}:${minutes}`;
                    }
                });

                return sortedData;
            },
        },
        props: ['data', 'type', 'title', 'link', 'courseClass'],
        methods: {
            declOfNum(n, titles) {
                return titles[(n % 10 === 1 && n % 100 !== 11) ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2]
            },
            duration(item){
                if(item){
                    if(item.type !== 3){
                        let h = Math.floor(item.duration / 60);
                        let m = item.duration - (h * 60);

                        if (h > 0)
                            if (m > 0)
                                return h + ' ' + this.declOfNum(h, this.hoursArr) + ' ' + m + ' ' + this.declOfNum(m, this.minuteArr);
                            else
                                return h + ' ' + this.declOfNum(h, this.hoursArr);
                        else
                            return m + ' ' + this.declOfNum(m, this.minuteArr);
                    }
                }
                return false
            },
            title_string(item){
                switch(item.type){
                    case 1:
                    case 2:
                        return this.courseTypeArr[item.type - 1] + ', ' + this.duration(item);
                    case 3:
                        return this.courseTypeArr[item.type - 1] + ', ' + item.lessons.length + ' ' + this.declOfNum(item.lessons.length, this.lessonsCountArr);
                    default:
                        return '';
                }
            }
        }
    }
</script>

<style lang="sass">
    .t-courses
        &__footer
            display: flex
            flex-direction: row
            justify-content: center
            align-items: center
            padding: 0 16px
            margin-bottom: 32px
        &__wrapperBtns
            display: flex
            flex-direction: row
            flex-wrap: wrap
            justify-content: flex-end
            align-items: center

        @media (max-width: 769px)
            &__header
                margin: 0 0 16px
            h2
                padding: 0 16px
                background: transparent

    .t-courses-table
        &__list
            margin: 0 0 32px
            display: flex
            flex-direction: column
            @media (min-width: 769px)
                .swiper-wrapper
                    display: block !important
                .swiper-slide
                    height: unset
        &__pagination
            margin: -16px auto 24px
    .t-courses-tableItem
        padding: 16px 0
        border-bottom: 1px solid $border
        display: flex
        flex-direction: row
        flex-wrap: wrap
        align-items: center
        position: relative
        justify-content: flex-start
        @media (max-width: 769px)
            // @extend %substrate 
            //не работает при медия запросах, нужно использовать @include substrate() 
            @include substrate() 
            height: 164px
            padding: 16px
            border-bottom: 1px solid transparent
        &__price
            min-width: 85px
            margin-right: 24px
            display: flex
            flex-direction: row
            flex-wrap: wrap
            align-items: center
            span
                font-weight: bold
                color: $blue
                margin-right: 5px
            @media (max-width: 769px)
                order: -1
        &__length
            min-width: 135px
            margin-right: 24px
            color: $blue
            font-size: 15px
            @media (max-width: 769px)
                width: 100%
        &__date
            margin-right: 24px
            @media (max-width: 769px)
                order: -1
            + .t-courses-tableItem__description
                max-width: calc(100% - 430px)
                @media (max-width: 1440px)
                    width: 100%
                    max-width: unset
        &__description
            font-weight: bold
            flex-grow: 1
            max-width: calc(100% - 292px)
            @media (max-width: 1440px)
                width: 100%
                max-width: unset
</style>


// WEBPACK FOOTER //
// src/vue_components/Courses/SmallTable.vue